import React from 'react'
import { Table, Typography } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { IMovementRS } from '../../../../models/storageModel'
import { getTopMovedProducts, TProductMovedRanking } from '../../../../utils/reportUtils'
import { TExcelColumn } from '../../../../utils/excelExport'
import { textNumberFormater } from '../../../../utils'

const { Text } = Typography

interface TopMovedProductsReportProps {
  data: IMovementRS[]
  loading?: boolean
}

export const topProductsExcelColumns: TExcelColumn[] = [
  { header: 'Código', key: 'itemCode', width: 18 },
  { header: 'Producto', key: 'itemName', width: 30 },
  { header: 'Cant. Entrada', key: 'entryQuantity', width: 14, format: 'number' },
  { header: 'Cant. Salida', key: 'exitQuantity', width: 14, format: 'number' },
  { header: 'Cant. Total Movida', key: 'totalQuantity', width: 16, format: 'number' },
  { header: 'Monto Total', key: 'totalAmount', width: 18, format: 'money' },
  { header: 'Precio Promedio', key: 'averagePrice', width: 16, format: 'money' },
  { header: 'Nº Transacciones', key: 'transactionCount', width: 16, format: 'number' }
]

export function getTopProductsExcelData(data: IMovementRS[]) {
  return getTopMovedProducts(data, 100)
}

export const TopMovedProductsReport: React.FC<TopMovedProductsReportProps> = ({ data, loading = false }) => {
  const ranking = getTopMovedProducts(data, 50)

  const columns: ColumnsType<TProductMovedRanking> = [
    {
      title: '#',
      key: 'index',
      width: 50,
      render: (_, __, index) => index + 1
    },
    {
      title: 'Código',
      dataIndex: 'itemCode',
      key: 'itemCode',
      width: 140,
      render: (text) => <code>{text || '-'}</code>
    },
    {
      title: 'Producto',
      dataIndex: 'itemName',
      key: 'itemName',
      ellipsis: true,
      render: (text) => <strong>{text}</strong>
    },
    {
      title: 'Cant. Entrada',
      dataIndex: 'entryQuantity',
      key: 'entryQuantity',
      width: 120,
      align: 'right',
      render: (val) => <Text style={{ color: '#52c41a' }}>{textNumberFormater(val)}</Text>
    },
    {
      title: 'Cant. Salida',
      dataIndex: 'exitQuantity',
      key: 'exitQuantity',
      width: 120,
      align: 'right',
      render: (val) => <Text style={{ color: '#ff4d4f' }}>{textNumberFormater(val)}</Text>
    },
    {
      title: 'Cant. Total',
      dataIndex: 'totalQuantity',
      key: 'totalQuantity',
      width: 120,
      align: 'right',
      sorter: (a, b) => a.totalQuantity - b.totalQuantity,
      render: (val) => <Text strong style={{ color: '#722ed1' }}>{textNumberFormater(val)}</Text>
    },
    {
      title: 'Monto Total',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      width: 160,
      align: 'right',
      sorter: (a, b) => a.totalAmount - b.totalAmount,
      render: (val) => <Text strong style={{ color: '#1890ff' }}>$ {textNumberFormater(val)}</Text>
    },
    {
      title: 'Precio Promedio',
      dataIndex: 'averagePrice',
      key: 'averagePrice',
      width: 140,
      align: 'right',
      render: (val) => `$ ${textNumberFormater(val)}`
    },
    {
      title: 'Transacciones',
      dataIndex: 'transactionCount',
      key: 'transactionCount',
      width: 120,
      align: 'right',
      render: (val) => textNumberFormater(val)
    }
  ]

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <Table<TProductMovedRanking>
        columns={columns}
        dataSource={ranking}
        loading={loading}
        pagination={{
          defaultPageSize: 15,
          showSizeChanger: true,
          pageSizeOptions: ['15', '30', '50'],
          showTotal: (total) => `Top ${total} productos movidos`
        }}
        size="small"
        bordered
        scroll={{ x: 'max-content' }}
      />
    </div>
  )
}

export default TopMovedProductsReport
